var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { CATEGORIES_LOADING, CATEGORIES_LOAD_FAILED, CATEGORIES_LOAD_SUCCESS, CATEGORY_ADD, CATEGORY_ADD_EDIT_CANCEL, CATEGORY_EDIT, CATEGORY_ITEMS_LOADING, CATEGORY_ITEMS_LOAD_FAILED, CATEGORY_ITEMS_LOAD_SUCCESS, CATEGORY_SAVE_FAILED, CATEGORY_SAVE_SUCCESS, CATEGORY_SAVING, CATEGORY_VIEW, ITEM_ADD, ITEM_ADD_EDIT_CANCEL, ITEM_EDIT, ITEM_SAVE_FAILED, ITEM_SAVE_SUCCESS, ITEM_SAVING } from '../actions/commissary';
var initialState = {
  loadingCategories: false,
  categories: null,
  error: null,
  viewCategory: null,
  viewCategoryItems: null,
  viewCategoryItemsLoading: false,
  viewCategoryItemsLoadError: null,
  addingCategory: false,
  editingCategory: null,
  savingCategory: false,
  savingCategoryError: null,
  addingItem: false,
  editingItem: null,
  savingItem: false,
  savingItemError: null
};
export default function (state, action) {
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {
    case CATEGORIES_LOADING:
      return __assign(__assign({}, state), {
        loadingCategories: true,
        categories: null,
        error: null
      });
    case CATEGORIES_LOAD_SUCCESS:
      return __assign(__assign({}, state), {
        loadingCategories: false,
        categories: action.categories.data,
        error: null
      });
    case CATEGORIES_LOAD_FAILED:
      return __assign(__assign({}, state), {
        loadingCategories: false,
        categories: null,
        error: action.error
      });
    case CATEGORY_VIEW:
      return __assign(__assign({}, state), {
        viewCategory: action.category
      });
    case CATEGORY_ITEMS_LOADING:
      return __assign(__assign({}, state), {
        viewCategoryItems: null,
        viewCategoryItemsLoading: true,
        viewCategoryItemsLoadError: null
      });
    case CATEGORY_ITEMS_LOAD_SUCCESS:
      return __assign(__assign({}, state), {
        viewCategoryItems: action.items,
        viewCategoryItemsLoading: false,
        viewCategoryItemsLoadError: null
      });
    case CATEGORY_ITEMS_LOAD_FAILED:
      return __assign(__assign({}, state), {
        viewCategoryItems: null,
        viewCategoryItemsLoading: false,
        viewCategoryItemsLoadError: action.error
      });
    case CATEGORY_ADD:
      return __assign(__assign({}, state), {
        addingCategory: true
      });
    case CATEGORY_ADD_EDIT_CANCEL:
      return __assign(__assign({}, state), {
        addingCategory: false,
        editingCategory: null
      });
    case CATEGORY_EDIT:
      return __assign(__assign({}, state), {
        editingCategory: action.category
      });
    case CATEGORY_SAVING:
      return __assign(__assign({}, state), {
        savingCategory: true,
        savingCategoryError: null
      });
    case CATEGORY_SAVE_SUCCESS:
      return __assign(__assign({}, state), {
        addingCategory: false,
        editingCategory: null,
        savingCategory: false,
        savingCategoryError: null,
        viewCategory: action.category
      });
    case CATEGORY_SAVE_FAILED:
      return __assign(__assign({}, state), {
        savingCategory: false,
        savingCategoryError: action.error
      });
    case ITEM_ADD:
      return __assign(__assign({}, state), {
        addingItem: true
      });
    case ITEM_ADD_EDIT_CANCEL:
      return __assign(__assign({}, state), {
        addingItem: false,
        editingItem: null
      });
    case ITEM_EDIT:
      return __assign(__assign({}, state), {
        editingItem: action.item
      });
    case ITEM_SAVING:
      return __assign(__assign({}, state), {
        savingItem: true,
        savingItemError: null
      });
    case ITEM_SAVE_SUCCESS:
      var updatedItems = state.viewCategoryItems;
      if (action.item && updatedItems) {
        updatedItems.data = state.viewCategoryItems.data.map(function (i) {
          if (i.id == action.item.id) {
            return action.item;
          }
          return i;
        });
      }
      return __assign(__assign({}, state), {
        addingItem: false,
        savingItem: false,
        savingItemError: null,
        editingItem: null,
        viewCategoryItems: updatedItems
      });
    case ITEM_SAVE_FAILED:
      return __assign(__assign({}, state), {
        savingItem: false,
        savingItemError: action.error
      });
  }
  return state;
}